<template>
  <div class="template">

    <h3>Mordet på Gustav III</h3>

    <p>
      Drottningens Juvelsmycke kretsar kring tiden före, under och efter mordet på Sveriges konung Gustav III. I tidslinjen nedan presenteras ett urval av händelserna kring kungamordet, såsom de porträttas i romanen.
    </p>

    <p class="instructions">
      Såhär gör du: Använd pilarna för att navigera framåt, eller klicka direkt på någon av historierutorna längsmed tidsaxeln.

      <ul>
         <li>
           Slides med vit bakgrund redogör för faktiska historiska händelser.
         </li>
         <li>
           Slides med röd bakgrund presenterar fiktiva händelser i romanen.
         </li>
      </ul>

    </p>

    <iframe src='https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1eqNYRh9w7VJECSpVXCWRMvIDKjmv80aOxHzowa8-bOY&font=Default&lang=en&initial_zoom=2&height=600' width='100%' height='600' webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder='0'></iframe>

  </div>
</template>

<script>
export default {
  name: 'DJTimeline',
  readable: 'Tidslinje',
  route: 'tidslinje',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.border{
  border: 1px solid gray;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/tabs/DJTimeline.vue